import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ClientDTO, FilterDTO, PagedResultDTOOfZoneDTO } from '../../../../../base/models/models.swagger.generated';
import { AutocompleteComponent } from '../../../../../base/shared/autocomplete/autocomplete.component';
import { ClientService } from '../../../../../base/services/client/client.service';
import { DeviceStatusReportService } from '../device-status-report.service';
import { Observable } from 'rxjs';
import { AutocompleteItem } from '../../../../../base/shared/autocomplete/autocomplete-item';
import { map } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { ClientAutocompleteComponent } from '../../../../../base/shared/client-autocomplete/client-autocomplete.component';

@Component({
    selector: 'app-device-status-form',
    templateUrl: './device-status-form.component.html',
    styleUrls: ['./device-status-form.component.scss'],
    imports: [
        ReactiveFormsModule,
        ClientAutocompleteComponent,
        AutocompleteComponent,
        TranslateModule
    ]
})
export class DeviceStatusFormComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() public form: UntypedFormGroup;

  @Output() public searchDTOChanged = new EventEmitter<FilterDTO[]>();

  @ViewChild(ClientAutocompleteComponent)
  public clientAutocomplete: ClientAutocompleteComponent;

  @ViewChild('companyAutocomplete')
  public companyAutocomplete: AutocompleteComponent;

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public set selectedClient(value: ClientDTO) {
    if (this.clientService.selectedClient != value) {
      this.clientService.selectedClient = value;
    }
    // Defer the event emission to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.onClientSelected(value);
    });
  }

  public get selectedZone(): number {
    if (this.form.get('zoneId').value === null) {
      return null;
    }
    return this.form.get('zoneId').value;
  }

  public set selectedZone(value: number) {
    //TODO Currently workaround
    //Check if actual record has been selected
    if (typeof value === 'number') {
      this.form.get('zoneId').setValue(value);
    } else {
      this.form.get('zoneId').setValue(null);
    }
  }

  public keyValueDropdownSettings = {text: 'name', value: 'id'};

  subscriptions = [];

  constructor(protected clientService: ClientService,
              private deviceStatusReportService: DeviceStatusReportService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.form.valueChanges.subscribe(() => {
        this.searchDTOChanged.emit();
      }));
  }

  ngAfterViewInit(): void {
    if (!this.selectedClient) {
      this.focusClientAutocomplete();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public onSearchTextChanged(searchText: string): void {
    this.form.get('searchText').setValue(searchText);
  }

  public onClientSelected(client: ClientDTO): void {
    if (client) {
      this.searchDTOChanged.emit();
    }
  }

  public searchZoneAutocompleteValues(searchText: string): Observable<AutocompleteItem[]> {
    return this.deviceStatusReportService.searchZones(searchText)
      .pipe(map((zoneAutocompleteValues: PagedResultDTOOfZoneDTO) => {
        const data: AutocompleteItem[] = [];
        zoneAutocompleteValues.items.forEach(zone => {
          data.push({id: zone.id, name: zone.name});
        });
        return data;
      }));
  }

  private focusClientAutocomplete(): void {
    if (this.clientAutocomplete) {
      this.clientAutocomplete.focus();
    }
  }
}
